export default __webpack_public_path__ + "static/media/group-6267.a0fd76eb.svg";